// Hooks
import { useRouter } from 'next/router';

import clsx from 'clsx';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import useToggle from '@/utils/hooks/utils/useToggle';

// Libs
import { giveawayPickerUrl } from '@/lib/urls/giveawayPickerUrl';

// Components
import Button from '@/components/base/Button';
import { selectedPostAtom } from '@/components/pages/giveaway-picker/Atoms/postsAtoms';
import { socialProfileAtom } from '@/components/pages/giveaway-picker/Atoms/socialProfileAtom';
// Atoms
import {
    currentStepAtom,
    nextStepAtom,
    previousStepAtom
} from '@/components/pages/giveaway-picker/Atoms/stepsAtoms';
import { ShareEmailModal } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/ShareEmailModal';

export function NavigationButtons() {
    const router = useRouter();
    const { t } = useTranslation();

    const currentStep = useAtomValue(currentStepAtom);
    const goToNextStep = useSetAtom(nextStepAtom);
    const goToPreviousStep = useSetAtom(previousStepAtom);

    const selectedProfile = useAtomValue(socialProfileAtom);

    const [selectedPost, setSelectedPost] = useAtom(selectedPostAtom);

    const { isOpen: isEmailModalOpen, toggle: toggleEmailModal } = useToggle();

    const handlePreviousClick = () => {
        if (currentStep === 1) {
            router.push(giveawayPickerUrl);
            return;
        }
        if (currentStep === 2) {
            setSelectedPost(null);
        }
        goToPreviousStep();
    };

    const isNextButtonDisabled = () => {
        if (currentStep === 1 && !selectedProfile) return true;
        if (currentStep === 2 && !selectedPost) return true;
        return false;
    };

    const handleNextClick = () => {
        if (currentStep === 3) {
            toggleEmailModal();
            return;
        }
        goToNextStep();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <div
                className={clsx('mt-4 flex w-full', {
                    'sticky bottom-0 z-20 mr-2 bg-white py-5':
                        currentStep === 2 || currentStep === 3,
                    'justify-between': currentStep !== 1,
                    'justify-end': currentStep === 1
                })}>
                <button
                    onClick={handlePreviousClick}
                    className={clsx(
                        'p-0 font-GMedium text-xs text-icoGray-500 underline focus:ring-0',
                        { hidden: currentStep === 1 }
                    )}
                    data-testid="previous-button">
                    {t('commons:back')}
                </button>
                <Button
                    onClick={handleNextClick}
                    data-testid="next-button"
                    disabled={isNextButtonDisabled()}>
                    {t('commons:next')}
                </Button>
            </div>
            <ShareEmailModal isOpen={isEmailModalOpen} toggle={toggleEmailModal} />
        </>
    );
}
